import { motion } from "framer-motion"
import { FiSearch, FiCheckCircle, FiTrendingUp, FiXCircle } from "react-icons/fi"
import { useLanguage } from "../contexts/LanguageContext"

const ControlsSectionComponent = ({ darkMode, setSelectedStatus, selectedStatus, searchQuery, setSearchQuery, cardBorder, buttonBg, buttonHoverBg, inputBg, inputBorder }) => {
  const { t } = useLanguage()

  const filters = [
    { key: "all",         label: t("all_products"),        icon: null },
    { key: "STABLE",      label: t("status_stable"),       icon: <FiCheckCircle /> },
    { key: "OPPORTUNITY", label: t("status_opportunity"),  icon: <FiTrendingUp /> },
    { key: "CRITICAL",    label: t("status_critical"),     icon: <FiXCircle /> },
  ]

  const activeClass = {
    all:         darkMode ? "bg-blue-500 text-white" : "bg-blue-600 text-white",
    STABLE:      darkMode ? "bg-green-500/20 text-green-400 border border-green-500" : "bg-green-100 text-green-800 border border-green-300",
    OPPORTUNITY: darkMode ? "bg-blue-500/20 text-blue-400 border border-blue-500"   : "bg-blue-100 text-blue-800 border border-blue-300",
    CRITICAL:    darkMode ? "bg-red-500/20 text-red-400 border border-red-500"     : "bg-red-100 text-red-800 border border-red-300",
  }

  return (
    <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.2 }} className="mb-8">
      <div className={`${darkMode ? "bg-gray-800/30" : "bg-white/50"} ${cardBorder} backdrop-blur-sm p-4 rounded-xl border`}>
        <div className={`flex flex-col md:flex-row gap-4 items-center justify-between`}>
          {/* Filter buttons */}
          <div className={`flex flex-wrap gap-2 `}>
            {filters.map(f => (
              <button key={f.key} onClick={() => setSelectedStatus(f.key)}
                className={`px-4 py-2 rounded-lg transition-all duration-300 flex items-center gap-2  ${selectedStatus === f.key ? activeClass[f.key] : `${buttonBg} ${buttonHoverBg}`}`}>
                {f.icon}{f.label}
              </button>
            ))}
          </div>

          {/* Search */}
          <div className="relative">
            <FiSearch className={`absolute  left-3 top-1/2 transform -translate-y-1/2 ${darkMode ? "text-gray-400" : "text-gray-500"}`} />
            <input
              type="text"
              placeholder={t("search_products")}
              value={searchQuery}
              onChange={e => setSearchQuery(e.target.value)}
              className={` pl-10 pr-4 py-2 ${inputBg} border ${inputBorder} rounded-lg focus:outline-none focus:ring-2 ${darkMode ? "focus:ring-blue-500" : "focus:ring-blue-600"} focus:border-transparent w-full md:w-64`}
            />
          </div>
        </div>
      </div>
    </motion.div>
  )
}

export default ControlsSectionComponent
